<template>
  <!--Filters Buttons-->
  <div class="md-layout-item md-size-15">
    <md-button class="icon-button-size-40 md-icon-button icon-button"
               :class="isRaised(item)"
               :disabled="disabled">

      <md-icon :class="isRaised(item, true)">sync_problem</md-icon>
    </md-button>
  </div>
</template>

<script>

  export default {
    name: "DiscrepancyIcon",
    components: {
    },
    props: {
      isRaised: {
        type: Function,
        reuired: true
      },
      item: {
        type: Boolean,
        reuired: true
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    methods: {}
  };

</script>
<style src="../filters.css"></style>
